import { useEffect } from 'react';

import { restoreDiagnoses } from './restoreDiagnoses';

/**
 * useDiagnosisRestore — 부팅에 한 번, 로컬 이력이 비어 있으면 서버 이력을 채운다
 * (`app.tsx`가 `useProfileSync` 옆에 나란히 부른다).
 *
 * **단일비행**: React StrictMode는 effect를 두 번 태운다 — `restoreDiagnoses` 자체는
 * 멱등(두 번째 실행 시 이미 채워진 로컬을 보고 조용히 return)이지만, 겹쳐 도는 두 요청이
 * 낭비다. `analyTransport.ts`의 `creating`과 같은 모양(모듈 스코프에 **맨 프로미스**를
 * 쥐고, 정리 체인은 따로 `void`)으로 막는다 — `firing`에 `.finally()` 체인을 직접 얹으면
 * (`restoreDiagnoses`가 내부에서 조용히 삼키지 못한 예외가 있을 때) 아무도 기다리지 않는
 * 그 체인이 unhandled rejection이 된다. 결과는 화면에 필요 없다 — 저장되면
 * `useDiagnoses()` 구독이 알아서 본다.
 */
let firing: Promise<void> | null = null;

export const useDiagnosisRestore = (): void => {
  useEffect(() => {
    if (firing === null) {
      firing = restoreDiagnoses();
      void firing.finally(() => {
        firing = null;
      });
    }
  }, []);
};
